<template>
  <div class="room-card" @click="onDetailClick">
    <div class="room-card-body" v-touch:hold="onTouchHold">
      <div class="room-card-content">
        <div class="room-name">{{ props.data.name }}</div>
        <div class="room-devices" v-if="devicesText.length > 0">
          <i class="fa-regular fa-lightbulb me-1 text-primary"></i>조명장치 : {{ devicesText }}
        </div>
      </div>
      <div class="room-card-chevron">
        <i class="fa-solid fa-chevron-right text-primary"></i>
      </div>
    </div>
    <RoomItemModal
      v-if="groupModal.visible"
      :visible="groupModal.visible"
      :okCallback="onUpdateGroupName"
      :cancelCallback="groupModal.hide"
      :roomName="props.data?.name || ''"
    />
  </div>
</template>

<script setup>
import { onMounted, defineProps, getCurrentInstance, computed, reactive } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import RoomItemModal from '@/views/rooms/components/RoomItemModal.vue';
import useModal from '@/common/hooks/useModal';
import Axios, { GroupApi, ZoneApi } from '@/api';
import useMqttControl from '@/common/hooks/useMqttControl';

const mqttControl = reactive(useMqttControl());
const { emit } = getCurrentInstance();
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();
const route = useRoute();
const props = defineProps(['index', 'data', 'onGroupUpdated']);
const store = useStore();
const groupModal = reactive(useModal());

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const backColor = computed(() => {
  if (props.index % 5 === 0) {
    return 'bg-gradient-custom-orange';
  } else if (props.index % 5 === 1) {
    return 'bg-gradient-custom-pink';
  } else if (props.index % 5 === 2) {
    return 'bg-gradient-custom-teal';
  } else if (props.index % 5 === 3) {
    return 'bg-gradient-custom-indigo';
  } else {
    return 'bg-gradient-custom-blue';
  }
});
const devicesText = computed(() => {
  let text = "";
  props.data?.devices?.filter(device => device.type == 1)
    .forEach(device => text += text.length > 0 ? ", " + device.name : device.name);
  return text;
})

onMounted(() => {
  console.log('ZoneItem.onMounted().props =>', props);
});

const onDetailClick = () => {
  if(!zone.value.isEditMode){
    emitter.emit('showPopAlert', {
      title: '세팅 모드',
      description: `세팅모드 화면으로 이동하시겠습니까?\n세팅모드 활성화시 모바일 기기에서 컨트롤이 제한됩니다.`,
      okCallback: async() => {
        const payload = {isEditMode:true}
        const result = await Axios.patch(
          ZoneApi.UPDATE_ZONE.replace(':id', zone.value._id),
          payload,
        );
        console.log(result);
        if (result.resultCode === '0000') {
          mqttControl.onPublishZone(zone.value._id, payload);
          router.push(`/settings/light/groups/${props.data._id}/devices`);
        }
      },
      cancelCallback:() =>{}
    });
    return;
  }

  router.push(`/settings/light/groups/${props.data._id}/devices`);
};

const onDeleteClick = () => {
  console.log('GroupItem.onDeleteClick =>', {
    name: props.data.name,
    groupId: props.data._id,
  });
  emit('onDeleteClick', { name: props.data.name, groupId: props.data._id });
};

const onTouchHold = () => {
  groupModal.show();
}

const onUpdateGroupName = (value) => {
  requestUpdateGroup({
    name: value,
  });
  groupModal.hide();
};

const requestUpdateGroup = async (params) => {
  try {
    const result = await Axios.patch(
      GroupApi.UPDATE_GROUP.replace(':id', props.data._id),
      params,
    );
    if (result.resultCode === '0000') {
      store.commit('home/updateGroup', {
        id: props.data._id,
        data: params,
      });
      emit('onGroupUpdated');
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '방 정보 수정에 실패했습니다.',
    });
  }
};
</script>

<style scoped>
.room-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}

.room-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.room-card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  min-height: 3rem;
}

.room-card-content {
  flex: 1;
  min-width: 0;
}

.room-name {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
}

.room-devices {
  font-size: 0.85rem;
  line-height: 1.5;
  color: #6c757d;
  margin-top: 0.2rem;
}

.room-card-chevron {
  flex-shrink: 0;
  margin-left: 0.5rem;
  font-size: 0.8rem;
}
</style>
